import { Col } from 'antd';
import { SignupViewPage } from 'features/auth/components/signup-form/signup-form';

import { StyledBackground, StyledCard, StyledRow } from './login.styles';

export const SignupPage = () => {
  return (
    <StyledBackground>
      <Col
        xs={24}
        sm={18}
        md={12}
        lg={12}
        xl={10}
        xxl={6}
        className='flex flex-col justify-center'
      >
        <Col xs={24} className='flex justify-center mb-10'>
          <img src='/partnerplus_logo.png' alt='login background' />
        </Col>
        <StyledCard className='sign_up_card'>
          <StyledRow justify='center'>
            <Col
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <label className='mt-0 mb-3 text-center text-2xl font-bold text-blue-950'>
                Signup in to your account
              </label>
            </Col>
          </StyledRow>
          <StyledRow justify='center'>
            <Col xs={24}>
              <SignupViewPage />
            </Col>
          </StyledRow>
        </StyledCard>
      </Col>
    </StyledBackground>
  );
};
